/**
 * 驗證電子發票手機載具
 * 格式：/4ALH+JQ
 */
export const validatePhoneCarrierNumber = (phoneCarrierNumber: string): boolean => {
  return /^\/[0-9A-Z.+-]{7}$/.test(phoneCarrierNumber)
}
